module.exports = __webpack_public_path__ + "static/media/cover.77dcc5e8.jpg";